export default "__VITE_ASSET__9c67fe9b__"